"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddLineOfCoverageType = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importStar(require("react"));
var line_of_coverage_type_select_input_1 = require("../line-of-coverage-type-select-input");
/**
 * Button that opens a modal that allows selecting a line of coverage.
 * Optionally you can pass a blacklist of line of coverage types that shouldn't be options.
 */
function AddLineOfCoverageType(_a) {
    var onSubmit = _a.onSubmit, _b = _a.blacklist, blacklist = _b === void 0 ? [] : _b;
    var _c = react_1.useState(false), isOpen = _c[0], setOpen = _c[1];
    var openModal = react_1.useCallback(function () { return setOpen(true); }, []);
    var closeModal = react_1.useCallback(function () { return setOpen(false); }, []);
    var _d = react_1.useState(), lineOfCoverageType = _d[0], setLineOfCoverageType = _d[1];
    var submit = react_1.useCallback(function () {
        if (!lineOfCoverageType)
            return;
        onSubmit(lineOfCoverageType);
        setLineOfCoverageType(undefined);
        closeModal();
    }, [onSubmit, lineOfCoverageType, closeModal]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_ui_1.TextLink, { onClick: openModal, style: { textDecoration: 'none' } }, "+ Add line of coverage"),
        react_1.default.createElement(core_ui_1.Modal, { isOpen: isOpen, onToggle: setOpen },
            react_1.default.createElement(core_ui_1.ModalBody, null,
                react_1.default.createElement(core_ui_1.ModalHeader, { titleText: "Add a line of coverage", onClose: closeModal }),
                react_1.default.createElement(core_ui_1.Padding, { size: 24 },
                    react_1.default.createElement(line_of_coverage_type_select_input_1.LineOfCoverageTypeSelectInput, { value: lineOfCoverageType, blacklist: blacklist, onChange: setLineOfCoverageType })),
                react_1.default.createElement(core_ui_1.ModalFooter, null,
                    react_1.default.createElement(core_ui_1.Stack, { gap: 12 },
                        react_1.default.createElement(core_ui_1.Button, { size: "secondary", onClick: closeModal }, "Cancel"),
                        react_1.default.createElement(core_ui_1.Button, { size: "primary", disabled: !lineOfCoverageType, onClick: submit }, "Add")))))));
}
exports.AddLineOfCoverageType = AddLineOfCoverageType;
